module.exports = __webpack_public_path__ + "static/media/mmm-agent-home.06e9176b.svg";